import Accordion from '../components/Accordion';

export default class DynamicFaq {
  constructor(section) {
    this._initAccordion(section);
  }

  _initAccordion(section) {
    const el = section.el.querySelector('[data-faq-block]');
    const tabletEl = section.el.querySelector('[data-faq-tablet-block]');
    const images = section.el.querySelectorAll('[data-dropdown-image]');

    if (!el) {
      return;
    }

    new Accordion({
      el: el,
      triggerClass: 'faq-trigger',
      contentClass: 'faq-content',
      closeOnClickOutside: false,
      onOpenEvent: function (attributeValue) {
        images.forEach(image => {
          if (image.getAttribute('data-dropdown-image') === attributeValue) {
            image.classList.add('faq-image--active');
          } else {
            image.classList.remove('faq-image--active');
          }
        });
      },
    });

    if (!tabletEl) {
      return;
    }

    new Accordion({
      el: tabletEl,
      triggerClass: 'faq-trigger',
      contentClass: 'faq-content',
      closeOnClickOutside: false,
      onOpenEvent: function (attributeValue) {
        images.forEach(image => {
          if (image.getAttribute('data-dropdown-image') === attributeValue) {
            image.classList.add('faq-image--active');
          } else {
            image.classList.remove('faq-image--active');
          }
        });
      },
    });
  }
}
